import { createAction } from "@reduxjs/toolkit";

const resetAll = createAction("RESET_ALL");

export {resetAll}